/* #2184 — the row Actions trigger is a 44×44 target on a COARSE pointer.
 *
 * ── the finding ────────────────────────────────────────────────────────────
 * Measured by #1982's four-viewport Console cards-lens browser proof: on a
 * coarse pointer the shared Actions trigger renders **26 × 44**. The shared
 * button already carries a 44px `min-height`, so the vertical half was solved
 * and the horizontal half was not — `min-width` stayed `auto`, and a single
 * `⋮` glyph is narrow. Its immediate neighbours, `rowPin` and `bandTwist`, are
 * 44 × 44, so the row offers three adjacent targets of which one is half-width.
 * That is WCAG 2.5.8 (Target Size, Minimum).
 *
 * ── why the fix lives HERE and not in the shared button ────────────────────
 * `packages/ui/src/controls/Button.module.css` is explicitly outside this
 * packet's carve, and widening `size="sm"` for every consumer would be the
 * wrong repair anyway: most small buttons carry a text label and are already
 * far wider than 44px, so a global minimum would change nothing for them while
 * re-spacing the few icon-only ones nobody measured. The gap is specific to an
 * icon-only trigger, so the minimum is applied where that trigger is composed.
 *
 * ── coarse pointer ONLY, and that is the load-bearing part ─────────────────
 * `@media (pointer: coarse)` so fine-pointer density is untouched: on a mouse
 * the trigger stays 26px wide and the row's rhythm is exactly what it was.
 * #2184 requires that in as many words — "without changing fine-pointer density
 * or visible label semantics" — and a mutation arm removes this minimum to
 * prove the browser matrix can see it.
 *
 * Nothing else changes: no padding, no font, no icon size, no geometry on the
 * card or the table. `min-width` alone cannot reflow a row that already
 * reserves 44px of height for its neighbours.
 */
@media (pointer: coarse) {
  .trigger { min-width: 44px; }
}
